import { createApp } from "vue";
import { objNamesToCamelCase } from "common/utils/helpers/cases";
import clickOutside from "components/jiffy/vue-cart/filters/clickOutside";
import NamedCartsConsumer from "../vue-cart/NamedCarts/NamedCartsConsumer.vue";
import i18n from "../vue-cart/vue-i18n";
import store from "../vue-cart/store";

export const provideNewCartsData = ({ customer, number }) => {
  store.commit("setOrderNumber", number);
  store.commit("savedCarts/setSavedCartsCustomer", objNamesToCamelCase(customer));
};

const initSavedCartsEditModalConsumer = async (id, props) => {
  const $root = document.querySelector(id);
  if (!$root) return;

  store.dispatch("initializeStore", {
    cartConfig: {
      isNamedCartsAvailable: true
    }
  });
  await store.dispatch("savedCarts/loadSavedCarts");

  const consumerField = createApp(NamedCartsConsumer, props);
  consumerField.use(store);
  consumerField.use(i18n);
  consumerField.directive("click-outside", clickOutside($root.closest(".modal")));
  consumerField.mount(id);
};

export const modalStore = store;

export default initSavedCartsEditModalConsumer;
